"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropAreaState = void 0;
const tslib_1 = require("tslib");
const rsync = tslib_1.__importStar(require("../../utils/rsync"));
/**
 * State container for the {@link DropArea} component. Holds whether a
 * drag is currently hovering the area, and exposes a {@link pick} method
 * that consumers can call to programmatically open a native file picker.
 */
class DropAreaState {
    constructor(
    /** Called when files are dropped or selected via the picker. */
    onFiles, 
    /** Called when a URI is dropped. */
    onUri, 
    /** Called when text is dropped. */
    onText, 
    /** Whether {@link pick} should allow selecting multiple files. */
    multiple = true, 
    /** `accept` attribute for the file picker. */
    accept) {
        this.onFiles = onFiles;
        this.onUri = onUri;
        this.onText = onText;
        this.multiple = multiple;
        this.accept = accept;
        /** Whether a file/item is currently being dragged over the area. */
        this.over = rsync.val(false);
        /** Hidden `<input type="file">` used by {@link pick}. */
        this.inputEl = null;
        this.setInputEl = (el) => {
            this.inputEl = el;
        };
        /** Programmatically open the native file picker. */
        this.pick = () => {
            this.inputEl?.click();
        };
    }
}
exports.DropAreaState = DropAreaState;
